import React from 'react';

/**
 * Design-system headset — the exported "Support, Help, Question/Headphones,
 * Customer, support" asset (Figma 2958:14255, the "Ask customer support"
 * action under a RudderAI answer). 16px box, 1px stroke; the stroke follows
 * `currentColor` so the hosting button owns the colour, like ThumbsUp.
 */
export const Headset: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6667 11.3333H12C11.632 11.3333 11.3333 11.0347 11.3333 10.6667V7.33333C11.3333 6.96533 11.632 6.66667 12 6.66667H12.6667C13.4033 6.66667 14 7.26333 14 8V10C14 10.7367 13.4033 11.3333 12.6667 11.3333Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 11.3333H3.33333C2.59667 11.3333 2 10.7367 2 10V8C2 7.26333 2.59667 6.66667 3.33333 6.66667H4C4.368 6.66667 4.66667 6.96533 4.66667 7.33333V10.6667C4.66667 11.0347 4.368 11.3333 4 11.3333Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3333 6.66667V6.33333C12.3333 3.94 10.3933 2 8 2V2C5.60667 2 3.66667 3.94 3.66667 6.33333V6.66667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.41667 14.1667H7.58333C7.12333 14.1667 6.75 13.7933 6.75 13.3333V13.3333C6.75 12.8733 7.12333 12.5 7.58333 12.5H8.41667C8.87667 12.5 9.25 12.8733 9.25 13.3333V13.3333C9.25 13.7933 8.87667 14.1667 8.41667 14.1667Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.25 13.3333H10.6667C11.4033 13.3333 12 12.7367 12 12V11.3333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
